// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.item-box {
  background: #fff;
  overflow: hidden;
  border: 1px solid #e3e3e2;
  padding: 15px;
  position: relative;
  height: 100%;
  border-radius: 15px;
}
.item-box .details-box {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  height: 100%;
}
.item-box .details-box .image-box {
  cursor: pointer;
  height: 140px;
  order: 0;
  overflow: hidden;
}
.item-box .details-box .title {
  font-size: 1rem;
  line-height: 1;
  min-height: 33px;
  order: 1;
}
.item-box .details-box .desc-box {
  overflow: hidden;
  text-align: start;
  min-height: 95px;
  order: 3;
}
.item-box .details-box .properties-box {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  order: 2;
  align-items: center;
}
.item-box .details-box .properties-box .item_code {
  color: #9d9d9d;
  font-size: 14px;
}
.item-box .details-box .properties-box .maker-img {
  height: 30px;
  line-height: 0.7;
}
.item-box .details-box .properties-box .maker-img span {
  font-size: 13px;
}
.item-box .details-box .props-content {
  order: 8;
  font-size: 12px;
  overflow: hidden;
  flex: 1;
}
.item-box .details-box .props-content .props-box {
  display: flex;
  gap: 0px 7px;
  flex-wrap: wrap;
  position: absolute;
}
.item-box .details-box .options-box {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: auto;
  gap: 2px;
  order: 4;
}
.item-box .details-box .options-box .cart-options {
  flex: auto;
}
.item-box .details-box .options-box .cart-options ion-buttons {
  display: flex;
  flex-direction: row;
  align-items: center;
  overflow: hidden;
  border: 1px solid #f5f5f5;
  border-radius: 5px;
}
.item-box .details-box .options-box .cart-options ion-buttons ion-button {
  width: 100%;
  font-size: 12px;
  height: 35px;
  background: none;
  --background: none;
  font-weight: bold;
  --padding-end: 0;
  --padding-start: 0;
}
.item-box .details-box .options-box .cart-options ion-buttons ion-button.amount-button {
  margin: 0;
  --background: var(--button-b-background);
  --color: var(--button-b-text);
  --border-radius: 7px;
  border-radius: 7px;
}
.item-box .details-box .options-box .cart-options ion-buttons.btn-outline ion-button {
  color: #565656 !important;
}
.item-box .details-box .options-box .cart-options ion-buttons.btn-outline ion-button.danger {
  color: #c97f7f !important;
}
.item-box .details-box .options-box .price-box {
  flex: 0 0 33%;
  height: auto;
  font-weight: bold;
  text-align: center;
  font-size: 1.2rem;
  color: #565656;
  justify-content: center;
}
.item-box .details-box .options-box .price-box ::ng-deep .price-div {
  line-height: 1;
  display: flex;
  gap: 5px;
  flex-direction: row;
  justify-content: center;
  align-items: flex-end;
}
.item-box .details-box .options-box .price-box ::ng-deep .oldprice {
  font-size: 15px;
  color: #aeaead;
  font-weight: initial;
}
.item-box .details-box .agent-tool-box {
  order: 5;
}
.item-box .details-box .extraData-box {
  order: 4;
  overflow-x: auto;
  margin-bottom: 4px;
}
.item-box .sale-span.flag ion-badge {
  padding: 4px 7px;
  padding-bottom: 6px;
  padding-right: 9px;
  margin: 1px 0px 0 0;
  border-radius: 10px;
  border-top-right-radius: 0;
  border-top-left-radius: 0;
  border-bottom-right-radius: 0;
}
.item-box .sale-span {
  position: absolute;
  top: -1px;
  right: -2px;
  left: auto;
  max-height: 34px;
  max-width: 120px;
  z-index: 1111;
}
.item-box .sale-span ion-badge {
  font-weight: bolder;
  font-size: 14px;
  white-space: pre-line;
  cursor: pointer;
  gap: 2px;
}
.item-box .sale-span ion-badge.active {
  --background: var(--button-b-background);
  --color: var(--button-b-text);
}
.item-box .sale-span.last-price {
  top: 0;
  left: 7px;
  right: inherit;
  bottom: inherit;
  align-items: flex-start;
}
.item-box .sale-span.last-price ion-badge {
  border-bottom-right-radius: 5px;
  border-bottom-left-radius: 5px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  font-size: 17px;
  display: flex;
  gap: 5px;
  font-weight: 100;
}

ion-badge {
  --color: #3c3c3c;
  --background: #f9f9f9;
}

.item-box.smaller .details-box .image-box {
  height: 50px;
  order: 0;
  overflow: hidden;
}

.item-box.bigger .details-box .image-box {
  height: 200px;
  order: 0;
  overflow: hidden;
}

@media (min-width: 450px) {
  .item-box.smaller .details-box .image-box {
    height: 95px;
    order: 0;
    overflow: hidden;
  }
}
.item-box.small .details-box {
  display: grid;
  grid-template-columns: 25% 75%;
  height: -moz-fit-content;
  height: fit-content;
}
.item-box.small .details-box .image-box {
  padding-left: 3px;
  height: 115px;
  grid-column: 1;
}
.item-box.small .details-box .item-content {
  grid-column: 2;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  width: 100%;
}
.item-box.small .details-box .item-content .properties-box {
  max-height: 30px;
  overflow: hidden;
}
.item-box.small .details-box .item-content .title, .item-box.small .details-box .item-content .desc-box, .item-box.small .details-box .item-content .options-box, .item-box.small .details-box .item-content .agent-tool-box, .item-box.small .details-box .item-content .properties-box {
  min-height: inherit;
  width: 100%;
}
.item-box.small .details-box .item-content .agent-tool-box ::ng-deep app-item-agent-tool .flex-grid {
  flex-wrap: nowrap;
  overflow-x: auto;
}
.item-box.small .details-box .item-content .agent-tool-box ::ng-deep app-item-agent-tool .flex-grid .grid-box {
  flex: 1 0 auto;
}
.item-box.small .details-box .item-content .options-box {
  margin-top: 5px;
}
.item-box.small .details-box .item-content .options-box .price-box .unit-price {
  gap: 0 !important;
}
.item-box.small .details-box .item-content .options-box .price-box .unit-price.not-in-cart {
  flex-direction: column;
}
.item-box.small .details-box .item-content .options-box .price-box ::ng-deep .price-div {
  flex-direction: column;
  align-items: center;
  gap: 0;
}
.item-box.small .details-box .item-content .options-box .price-box ::ng-deep .price-div .oldprice {
  font-size: 15px;
}

.packageUnits {
  font-size: 12px;
  word-wrap: break-word;
  text-align: center;
  padding: 4px 10px;
  line-height: 0.8;
  display: flex;
  flex-direction: column;
  gap: 2px;
  /* margin: 1px 4px; */
  width: min-content;
  border-radius: 7px;
  color: #3c3c3c;
  background: #f9f9f9;
}
.packageUnits span {
  white-space: nowrap;
}

.extraData-box::-webkit-scrollbar {
  display: none;
}

.extraData-box:hover {
  overflow-x: scroll; /* Always show horizontal scrollbar on hover */
}

/* Optional: Customize scrollbar appearance for WebKit browsers */
.extraData-box:hover::-webkit-scrollbar {
  display: inherit;
  height: 12px;
}

.extraData-box:hover::-webkit-scrollbar-thumb {
  background-color: #999;
  border-radius: 6px;
}

.extraData-box:hover::-webkit-scrollbar-track {
  background-color: #eee;
}

.item-box.big .details-box {
  gap: 15px;
}
.item-box.big .details-box .options-box {
  flex-direction: column-reverse;
  align-items: flex-end;
  gap: 2px;
  margin-top: 5px;
}
.item-box.big .details-box .options-box .cart-options {
  width: 100%;
}
.item-box.big .details-box .options-box .price-box {
  width: -moz-fit-content;
  width: fit-content;
}
.item-box.big .details-box .options-box .price-box .flex-column {
  flex-direction: initial !important;
  gap: 10px;
}
.item-box.big .details-box > * {
  width: 100%;
}
.item-box.big .sale-span.last-price {
  display: flex;
  flex-direction: column-reverse;
  justify-content: flex-end;
  left: 0;
  top: 5px;
}
.item-box.big .sale-span.last-price ion-badge {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
  border-bottom-right-radius: 5px;
  border-top-right-radius: 5px;
}

.subtitle.stock {
  text-align: center;
  line-height: 1;
}

.item-box.small.agent-tool .details-box .title .properties-box {
  max-height: 20px;
  font-size: 13px;
  white-space: nowrap;
}

ion-badge.unit-price {
  font-weight: 100;
  gap: 2px;
}
ion-badge.unit-price ::ng-deep .price-div .oldprice {
  font-size: 12px !important;
}

.cart-options ::ng-deep .flex-grid {
  border: 0;
}
.cart-options ::ng-deep .flex-grid .grid-box {
  padding: 7px 0 !important;
  border: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/core/pages/item/components/item-box/item-box.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EAEA,gBAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;AAAF;AAEE;EACE,aAAA;EAEA,eAAA;EACA,sBAAA;EACA,YAAA;AADJ;AAII;EAEE,eAAA;EACA,aAAA;EACA,QAAA;EACA,gBAAA;AAHN;AAMI;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,QAAA;AAJN;AAOI;EACE,gBAAA;EACA,iBAAA;EACA,gBAAA;EAEA,QAAA;AANN;AASI;EACE,aAAA;EAEA,8BAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AARN;AAUM;EACE,cAAA;EACA,eAAA;AARR;AAWM;EAEE,YAAA;EACA,gBAAA;AAVR;AAYQ;EACE,eAAA;AAVV;AAeI;EACE,QAAA;EACA,eAAA;EACA,gBAAA;EACA,OAAA;AAbN;AAeM;EACE,aAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;AAbR;AAkBI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EAEA,mBAAA;EACA,gBAAA;EACA,QAAA;EAEA,QAAA;AAlBN;AAoBM;EACE,UAAA;AAlBR;AAoBQ;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EAEA,yBAAA;EACA,kBAAA;AAnBV;AAqBU;EACE,WAAA;EACA,eAAA;EACA,YAAA;EAGA,gBAAA;EACA,kBAAA;EAEA,iBAAA;EACA,gBAAA;EACA,kBAAA;AAtBZ;AAyBU;EACE,SAAA;EACA,wCAAA;EACA,6BAAA;EACA,oBAAA;EACA,kBAAA;AAvBZ;AAgCU;EACE,yBAAA;AA9BZ;AAiCU;EACE,yBAAA;AA/BZ;AAoCM;EACE,aAAA;EAEA,YAAA;EAEA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EAEA,uBAAA;AArCR;AAwCU;EACE,cAAA;EACA,aAAA;EACA,QAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;AAtCZ;AAyCU;EACE,eAAA;EACA,cAAA;EACA,oBAAA;AAvCZ;AA6CI;EACE,QAAA;AA3CN;AA8CI;EACE,QAAA;EACA,gBAAA;EACA,kBAAA;AA5CN;AAiDI;EACE,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,0BAAA;EACA,yBAAA;EACA,6BAAA;AA/CN;AAmDE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;AAjDJ;AAmDI;EACE,mBAAA;EACA,eAAA;EACA,qBAAA;EACA,eAAA;EACA,QAAA;AAjDN;AAoDI;EACE,wCAAA;EACA,6BAAA;AAlDN;AAuDE;EACE,MAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;EACA,uBAAA;AArDJ;AAuDI;EACE,+BAAA;EACA,8BAAA;EACA,yBAAA;EACA,0BAAA;EAEA,eAAA;EACA,aAAA;EACA,QAAA;EACA,gBAAA;AAtDN;;AA4DA;EAGE,gBAAA;EACA,qBAAA;AA3DF;;AAgEI;EAEE,YAAA;EACA,QAAA;EACA,gBAAA;AA9DN;;AAqEI;EAEE,aAAA;EACA,QAAA;EACA,gBAAA;AAnEN;;AAwEA;EAIM;IAEE,YAAA;IACA,QAAA;IACA,gBAAA;EAzEN;AACF;AAgFE;EAKE,aAAA;EACA,8BAAA;EACA,wBAAA;EAAA,mBAAA;AAlFJ;AAqFI;EAGE,iBAAA;EACA,aAAA;EAGA,cAAA;AAvFN;AA0FI;EACE,cAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AAxFN;AA0FM;EACE,gBAAA;EACA,gBAAA;AAxFR;AA2FM;EACE,mBAAA;EAGA,WAAA;AA3FR;AAiGU;EACE,iBAAA;EACA,gBAAA;AA/FZ;AAiGY;EACE,cAAA;AA/Fd;AAqGM;EACE,eAAA;AAnGR;AAwGU;EACE,iBAAA;AAtGZ;AAyGU;EACE,sBAAA;AAvGZ;AA2GY;EACE,sBAAA;EACA,mBAAA;EACA,MAAA;AAzGd;AA2Gc;EACE,eAAA;AAzGhB;;AAoHA;EACE,eAAA;EACA,qBAAA;EAEA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;AAlHF;AAoHE;EACE,mBAAA;AAlHJ;;AAsHA;EACE,aAAA;AAnHF;;AAsHA;EACE,kBAAA,EAAA,8CAAA;AAnHF;;AAsHA,iEAAA;AACA;EACE,gBAAA;EACA,YAAA;AAnHF;;AAsHA;EACE,sBAAA;EACA,kBAAA;AAnHF;;AAsHA;EACE,sBAAA;AAnHF;;AAwHE;EACE,SAAA;AArHJ;AAuHI;EACE,8BAAA;EACA,qBAAA;EACA,QAAA;EAEA,eAAA;AAtHN;AAwHM;EACE,WAAA;AAtHR;AAyHM;EACE,uBAAA;EAAA,kBAAA;AAvHR;AAyHQ;EACE,kCAAA;EACA,SAAA;AAvHV;AA6HE;EACE,WAAA;AA3HJ;AA8HE;EACE,aAAA;EACA,8BAAA;EACA,yBAAA;EACA,OAAA;EACA,QAAA;AA5HJ;AA8HI;EACE,4BAAA;EACA,yBAAA;EACA,+BAAA;EACA,4BAAA;AA5HN;;AAiIA;EACE,kBAAA;EACA,cAAA;AA9HF;;AAqII;EACE,gBAAA;EACA,eAAA;EACA,mBAAA;AAlIN;;AA2IA;EACE,gBAAA;EACA,QAAA;AAxIF;AA4IM;EACE,0BAAA;AA1IR;;AAmJI;EACE,SAAA;AAhJN;AAuJM;EACE,yBAAA;EAEA,oBAAA;AAtJR","sourcesContent":[".item-box {\n  background: #fff;\n  //background: linear-gradient(6deg, #fcf5f5 0%, #ffffff 59%, #ffffff 267%, white 100%);\n  overflow: hidden;\n  border: 1px solid #e3e3e2;\n  padding: 15px;\n  position: relative;\n  height: 100%;\n  border-radius: 15px;\n\n  .details-box {\n    display: flex;\n    //justify-content: space-between;\n    flex-wrap: wrap;\n    flex-direction: column;\n    height: 100%;\n    //gap: 2px;\n\n    .image-box {\n      //width: 15%;\n      cursor: pointer;\n      height: 140px;\n      order: 0;\n      overflow: hidden;\n    }\n\n    .title {\n      font-size: 1rem;\n      line-height: 1;\n      min-height: 33px;\n      order: 1;\n    }\n\n    .desc-box {\n      overflow: hidden;\n      text-align: start;\n      min-height: 95px;\n\n      order: 3;\n    }\n\n    .properties-box {\n      display: flex;\n      //align-items: center;\n      justify-content: space-between;\n      flex-direction: row;\n      order: 2;\n      align-items: center;\n\n      .item_code {\n        color: #9d9d9d;\n        font-size: 14px;\n      }\n\n      .maker-img {\n        //padding: 3px;\n        height: 30px;\n        line-height: 0.7;\n\n        span {\n          font-size: 13px;\n        }\n      }\n    }\n\n    .props-content {\n      order: 8;\n      font-size: 12px;\n      overflow: hidden;\n      flex: 1;\n\n      .props-box {\n        display: flex;\n        gap: 0px 7px;\n        flex-wrap: wrap;\n        position: absolute;\n      }\n    }\n\n\n    .options-box {\n      display: flex;\n      flex-direction: row;\n      justify-content: space-between;\n      //margin-top: 2px;\n      align-items: center;\n      margin-top: auto;\n      gap: 2px;\n\n      order: 4;\n\n      .cart-options {\n        flex: auto;\n\n        ion-buttons {\n          display: flex;\n          flex-direction: row;\n          align-items: center;\n          overflow: hidden;\n\n          border: 1px solid #f5f5f5;\n          border-radius: 5px;\n\n          ion-button {\n            width: 100%;\n            font-size: 12px;\n            height: 35px;\n            //max-width: 150px;\n\n            background: none;\n            --background: none;\n\n            font-weight: bold;\n            --padding-end: 0;\n            --padding-start: 0;\n          }\n\n          ion-button.amount-button {\n            margin: 0;\n            --background: var(--button-b-background);\n            --color: var(--button-b-text);\n            --border-radius: 7px;\n            border-radius: 7px;\n            //border: 1px solid #e3e3e2;\n          }\n        }\n\n        ion-buttons.btn-outline {\n          //border: 1px solid #f5f5f5;\n          //border-radius: 4px;\n\n          ion-button {\n            color: #565656 !important;\n          }\n\n          ion-button.danger {\n            color: #c97f7f !important;\n          }\n        }\n      }\n\n      .price-box {\n        flex: 0 0 33%;\n\n        height: auto;\n\n        font-weight: bold;\n        text-align: center;\n        font-size: 1.2rem;\n        color: #565656;\n\n        justify-content: center;\n\n        ::ng-deep {\n          .price-div {\n            line-height: 1;\n            display: flex;\n            gap: 5px;\n            flex-direction: row;\n            justify-content: center;\n            align-items: flex-end;\n          }\n\n          .oldprice {\n            font-size: 15px;\n            color: #aeaead;\n            font-weight: initial;\n          }\n        }\n      }\n    }\n\n    .agent-tool-box {\n      order: 5;\n    }\n\n    .extraData-box {\n      order: 4;\n      overflow-x: auto;\n      margin-bottom: 4px;\n    }\n  }\n\n  .sale-span.flag {\n    ion-badge {\n      padding: 4px 7px;\n      padding-bottom: 6px;\n      padding-right: 9px;\n      margin: 1px 0px 0 0;\n      border-radius: 10px;\n      border-top-right-radius: 0;\n      border-top-left-radius: 0;\n      border-bottom-right-radius: 0;\n    }\n  }\n\n  .sale-span {\n    position: absolute;\n    top: -1px;\n    right: -2px;\n    left: auto;\n    max-height: 34px;\n    max-width: 120px;\n    z-index: 1111;\n\n    ion-badge {\n      font-weight: bolder;\n      font-size: 14px;\n      white-space: pre-line;\n      cursor: pointer;\n      gap: 2px;\n    }\n\n    ion-badge.active {\n      --background: var(--button-b-background);\n      --color: var(--button-b-text);\n    }\n  }\n\n\n  .sale-span.last-price {\n    top: 0;\n    left: 7px;\n    right: inherit;\n    bottom: inherit;\n    align-items: flex-start;\n\n    ion-badge {\n      border-bottom-right-radius: 5px;\n      border-bottom-left-radius: 5px;\n      border-top-left-radius: 0;\n      border-top-right-radius: 0;\n\n      font-size: 17px;\n      display: flex;\n      gap: 5px;\n      font-weight: 100;\n    }\n  }\n\n}\n\nion-badge {\n  //--background: var(--button-b-background);\n  //--color: var(--button-b-text);\n  --color: #3c3c3c;\n  --background: #f9f9f9;\n}\n\n.item-box.smaller {\n  .details-box {\n    .image-box {\n      //width: 15%;\n      height: 50px;\n      order: 0;\n      overflow: hidden;\n    }\n  }\n}\n\n.item-box.bigger {\n  .details-box {\n    .image-box {\n      //width: 15%;\n      height: 200px;\n      order: 0;\n      overflow: hidden;\n    }\n  }\n}\n\n@media (min-width: 450px) {\n\n  .item-box.smaller {\n    .details-box {\n      .image-box {\n        //width: 15%;\n        height: 95px;\n        order: 0;\n        overflow: hidden;\n      }\n    }\n  }\n}\n\n.item-box.small {\n\n  .details-box {\n\n    //flex-flow: column wrap;\n    //height: 120px;\n    //height: inherit;\n    display: grid;\n    grid-template-columns: 25% 75%;\n    height: fit-content;\n\n\n    .image-box {\n      //flex: 1 0 100%;\n      //width: 25%;\n      padding-left: 3px;\n      height: 115px;\n      //max-width: 120px;\n\n      grid-column: 1;\n    }\n\n    .item-content {\n      grid-column: 2;\n      margin-top: 20px;\n      display: flex;\n      flex-direction: column;\n      width: 100%;\n\n      .properties-box {\n        max-height: 30px;\n        overflow: hidden;\n      }\n\n      .title, .desc-box, .options-box, .agent-tool-box, .properties-box {\n        min-height: inherit;\n        //flex: 1;\n        //width: -webkit-fill-available;\n        width: 100%;\n\n      }\n\n      .agent-tool-box {\n        ::ng-deep {\n          app-item-agent-tool .flex-grid {\n            flex-wrap: nowrap;\n            overflow-x: auto;\n\n            .grid-box {\n              flex: 1 0 auto;\n            }\n          }\n        }\n      }\n\n      .options-box {\n        margin-top: 5px;\n\n        .price-box {\n          //max-height: 37px;\n\n          .unit-price {\n            gap: 0 !important;\n          }\n\n          .unit-price.not-in-cart {\n            flex-direction: column;\n          }\n\n          ::ng-deep {\n            .price-div {\n              flex-direction: column;\n              align-items: center;\n              gap: 0;\n\n              .oldprice {\n                font-size: 15px;\n              }\n            }\n          }\n        }\n      }\n    }\n\n  }\n}\n\n.packageUnits {\n  font-size: 12px;\n  word-wrap: break-word;\n  //font-style: italic;\n  text-align: center;\n  padding: 4px 10px;\n  line-height: 0.8;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  /* margin: 1px 4px; */\n  width: min-content;\n  border-radius: 7px;\n  color: #3c3c3c;\n  background: #f9f9f9;\n\n  span {\n    white-space: nowrap;\n  }\n}\n\n.extraData-box::-webkit-scrollbar {\n  display: none;\n}\n\n.extraData-box:hover {\n  overflow-x: scroll; /* Always show horizontal scrollbar on hover */\n}\n\n/* Optional: Customize scrollbar appearance for WebKit browsers */\n.extraData-box:hover::-webkit-scrollbar {\n  display: inherit;\n  height: 12px;\n}\n\n.extraData-box:hover::-webkit-scrollbar-thumb {\n  background-color: #999;\n  border-radius: 6px;\n}\n\n.extraData-box:hover::-webkit-scrollbar-track {\n  background-color: #eee;\n}\n\n.item-box.big {\n\n  .details-box {\n    gap: 15px;\n\n    .options-box {\n      flex-direction: column-reverse;\n      align-items: flex-end;\n      gap: 2px;\n\n      margin-top: 5px;\n\n      .cart-options {\n        width: 100%;\n      }\n\n      .price-box {\n        width: fit-content;\n\n        .flex-column {\n          flex-direction: initial !important;\n          gap: 10px;\n        }\n      }\n    }\n  }\n\n  .details-box > * {\n    width: 100%;\n  }\n\n  .sale-span.last-price {\n    display: flex;\n    flex-direction: column-reverse;\n    justify-content: flex-end;\n    left: 0;\n    top: 5px;\n\n    ion-badge {\n      border-bottom-left-radius: 0;\n      border-top-left-radius: 0;\n      border-bottom-right-radius: 5px;\n      border-top-right-radius: 5px;\n    }\n  }\n}\n\n.subtitle.stock {\n  text-align: center;\n  line-height: 1;\n}\n\n.item-box.small.agent-tool {\n  .details-box {\n    //height: 120px;\n\n    .title .properties-box {\n      max-height: 20px;\n      font-size: 13px;\n      white-space: nowrap;\n    }\n  }\n}\n\n.item-box.inCart {\n  //border-color: var(--button-a-background);\n}\n\nion-badge.unit-price {\n  font-weight: 100;\n  gap: 2px;\n\n  ::ng-deep {\n    .price-div {\n      .oldprice {\n        font-size: 12px !important;\n      }\n    }\n  }\n}\n\n.cart-options {\n  ::ng-deep {\n    //app-item-agent-tool{\n    .flex-grid {\n      border: 0;\n      //border-top: 0;\n      //border-bottom: 0;\n      //background: none;\n      //.grid-box:not(.active){\n      //  background: none !important;\n      //}\n      .grid-box {\n        padding: 7px 0 !important;\n\n        border: 0 !important;\n      }\n    }\n  }\n\n  //}\n}\n\n//\n//@media (max-width: 545px) {\n//  .item-box.small.agent-tool {\n//    .details-box {\n//      height: 140px;\n//\n//      .agent-tool-box {\n//        ::ng-deep {\n//          app-item-agent-tool .flex-grid {\n//            flex-wrap: wrap;\n//            overflow-x: inherit;\n//          }\n//        }\n//      }\n//    }\n//  }\n//}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
